import React, { useEffect, useState } from 'react';
import L from "leaflet";
import { Departamento, DetallesCapis, getOrDeleteRequest } from '../utils/utils';
import logoPrivadas from "../assets/images/ubicacionPrivadas.png"
import logoPatronales from "../assets/images/ubicacionPatronales.png"
import logoPublicas from "../assets/images/ubicacionPublicas.png"
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import MyMap from '../components/myMap';

function MapaCapis() {
    const departamentosEstaticos = [
        ["Santa Ana", "San Salvador", "Cuscatlán", "San Miguel"],
        ["Ahuachapán", "La Libertad", "Cabañas", "Usulután"],
        ["Sonsonate", "Chalatenango", "La Paz", "La Unión"],
        ["", "", "San Vicente", "Morazán"]
    ];

    const [capis, setCapis] = useState([]);
    const [selectedPosition, setSelectedPosition] = useState(null);
    const [departamentos, setDepartamentos] = useState([]);
    const navigate = useNavigate();

    async function getCapis() {
        let capis = await DetallesCapis();
        console.log(capis);
        setCapis(capis);
    }

    async function getDepartamentos() {
        let data = await Departamento(); // Asegúrate de que devuelve datos en formato esperado
        console.log("Datos de departamentos:", data);

        const datosMapeados = {};
        data.forEach(dep => {
            datosMapeados[dep.name] = dep.id;
        });

        setDepartamentos(datosMapeados); // Ahora departamentos es un objeto { name: id }
    }

    useEffect(function () {
        getCapis();
        getDepartamentos();
    }, []);

    const [capisPorDepartamento, setCapisPorDepartamento] = useState({});

    const getCapisPorDepartamento = async () => {
        if (!departamentos || Object.keys(departamentos).length === 0) return;

        let response = await getOrDeleteRequest(
            'capis/by-state/grouped',
            'GET',
            null,
            false
        );

        if (response.type === "error") {
            console.log(response.message);
            return;
        }
        
        let capisByState = {};

        (response.data).forEach((item) => {
            capisByState[item.state] = item.total;
        });

        setCapisPorDepartamento(capisByState);
    }

    useEffect(() => {
        if (Object.keys(departamentos).length > 0) {
            getCapisPorDepartamento();
        }
    }, [departamentos]);

    const icons = {
        Privado: L.icon({
            iconUrl: logoPrivadas,
            iconSize: [38, 38],
        }),
        Patronal: L.icon({
            iconUrl: logoPatronales,
            iconSize: [38, 38],
        }),
        Publico: L.icon({
            iconUrl: logoPublicas,
            iconSize: [38, 38],
        })
    }

    const handleDepartamentoClick = (name) => {
        // console.log("Departamento clickeado:", name);
        // console.log("ID encontrado:", departamentos[name]);
        const id = departamentos[name];
        if (id) {
            navigate(`/DetallesDepartamento/${id}`);
        }
    };

    return (
        <div className="w-full h-full">
            <div className="flex flex-wrap mb-2 w-full">
                <h1 className="text-2xl md:text-4xl font-bold w-full text-custom-main text-center mb-5">
                    Localización de centros CAPI
                </h1>
                <div className='w-full flex items-center justify-center'>
                    <div className='w-full p-5'>
                        <MyMap height="50vh" width="100%" className="map" />
                    </div>
                </div>
            </div>
            <>
                <div className="overflow-x-auto">
                    <table className="border table-auto border-collapse w-full rounded-2xl">
                        <thead className="bg-custom-main text-white font-bold">
                            <tr>
                                <th className="border p-2">Zona Oriental</th>
                                <th className="border p-2">Zona Central</th>
                                <th className="border p-2">Zona Paracentral</th>
                                <th className="border p-2">Zona Occidental</th>
                            </tr>
                        </thead>
                        <tbody className="text-center bg-custom-cyan">
                            {departamentosEstaticos.map((fila, rowIndex) => (
                                <tr key={rowIndex}>
                                    {fila.map((departamento, colIndex) => (
                                        <td
                                            key={colIndex}
                                            className={`border p-2 ${departamento ? 'cursor-pointer transition-colors hover:bg-custom-cyan-hover hover:text-black' : ''}`}
                                            data-id={departamentos[departamento] || ""}
                                            onClick={() => departamento && handleDepartamentoClick(departamento)}
                                        >
                                            {departamento}
                                            {departamento && capisPorDepartamento[departamento] !== undefined && (
                                                <span className="block text-base w-auto">
                                                    {capisPorDepartamento[departamento]}
                                                </span>
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </>
        </div>
    )
}

export default MapaCapis;